import { Ripple } from "@/shared/ui/Ripple";

export class PayButton {
    private $element: JQuery;
    public onClick?: { () };
    public onDisabledClick?: { () };

    private lastAmount = "";
    private lastAction = "";

    constructor(action: string, element?: JQuery) {
        this.$element = element ?? $('<button class="paybtn interactable" />');

        if (action !== undefined) this.setAction(action);

        Ripple.bind(
            this.$element.click((e) => {
                e.preventDefault();

                if (this.isDisabled()) {
                    if (this.onDisabledClick !== undefined) this.onDisabledClick();

                    e.stopPropagation();
                    return false;
                } else {
                    if (this.onClick !== undefined) this.onClick();
                }
            })
        );
    }

    public setAmount(amount: number | string): PayButton {
        if (amount + "" === this.lastAmount) return this;

        this.lastAmount = amount + "";
        this.setAmountText(this.lastAmount);

        return this;
    }

    public setAction(act: string): PayButton {
        if (act === this.lastAction) return this;

        this.lastAction = act + "";
        this.setActionText(this.lastAction);

        return this;
    }

    public setDisabled(message?: string, showAsActive: boolean = false): PayButton {
        this.$element.removeClass("fake-active");

        if (message !== undefined && message !== this.$element.find("> .pbih.amount").text())
            this.setAmountText(message);

        if (!this.isDisabled()) {
            this.$element.addClass("disabled");

            return this;
        }

        if (showAsActive) this.$element.addClass("fake-active");

        return this;
    }

    public isDisabled(): boolean {
        return this.$element.hasClass("disabled");
    }

    public setEnabled(message?: string): PayButton {
        if (!this.isDisabled()) return this;

        this.$element.removeClass("fake-active");
        this.$element.removeClass("disabled");
        if (this.lastAmount !== this.$element.find("> .pbih.amount").text()) this.setAmountText(this.lastAmount);

        if (this.lastAction !== this.$element.find("> .pbih.action").text()) this.setActionText(this.lastAction);

        if (message !== undefined) {
            this.setActionText(message);
        }

        return this;
    }

    private setAmountText(txt?: string) {
        this.setText("amount", txt);
    }

    private setActionText(txt?: string) {
        this.setText("action", txt);
    }

    private setText(cssClass: string, txt?: string) {
        const existingInner = this.$element.find("> ." + cssClass);
        if (existingInner.length !== 0) {
            if (existingInner.text() === txt) {
                existingInner.stop(true, true);
                return;
            }

            existingInner
                .stop(true, true)
                .addClass("animout")
                .delay(300)
                .queue((n) => {
                    existingInner.remove();
                    n();
                });
        }

        const newInner = $('<div class="pbih ' + cssClass + '">' + txt + "</div>").appendTo(this.$element);
        newInner
            .stop(true, true)
            .delay(100)
            .queue((e) => {
                newInner.addClass("shown");
                e();
            });

        this.$element.append(newInner);
    }

    public appendTo($element: JQuery): PayButton {
        this.$element.appendTo($element);
        return this;
    }
}
